
import { Tbl_partitaEdit } from './tbl_partitaEdit';
import { Tbl_partitaList } from './tbl_partitaList';
import { Tbl_partitaShow } from './tbl_partitaShow';
import { Tbl_partitaCreate } from './tbl_partitaCreate';
import MapIcon from '@material-ui/icons/Map';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: Tbl_partitaList,
    edit: Tbl_partitaEdit,
    show: Tbl_partitaShow,
    create: Tbl_partitaCreate,
    icon: MapIcon
};
            